import { UserRoles } from '@/enums';
import { SharedCartPages } from '@/modules/cart/shared/types';

const access_roles = {
  [SharedCartPages.CART]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
    UserRoles.Internal.ENGINEER && UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.ENGINEER && UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.ENGINEER && UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.ENGINEER && UserRoles.Internal.SERVICE_MANAGER,
  ],
  [SharedCartPages.DETAIL]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
    UserRoles.Internal.ENGINEER && UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.ENGINEER && UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.ENGINEER && UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.ENGINEER && UserRoles.Internal.SERVICE_MANAGER,
  ],
  [SharedCartPages.CARTS_HISTORY]: [
    UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.SERVICE_MANAGER,
    UserRoles.Internal.ENGINEER && UserRoles.Internal.PARTNER_MANAGER,
    UserRoles.Internal.ENGINEER && UserRoles.Internal.VICE_PARTNER_MANAGER,
    UserRoles.Internal.ENGINEER && UserRoles.Internal.PURCHASING_MANAGER,
    UserRoles.Internal.ENGINEER && UserRoles.Internal.SERVICE_MANAGER,
  ],
};

export default access_roles;
